export type LocaleType = 'sv-SE' | 'da-DK' | 'nb-NO' | 'fi-FI';
export type LanguageType = 'sv' | 'da' | 'nb' | 'fi' | 'en';
export type TimeZoneType =
  | 'Europe/Stockholm'
  | 'Europe/Copenhagen'
  | 'Europe/Oslo'
  | 'Europe/Helsinki';

export type CurrencyType = 'SEK' | 'DKK' | 'NOK' | 'EUR';
export const countryCodes = ['SE', 'DK', 'NO', 'FI'] as const;
export type CountryCodeType = (typeof countryCodes)[number];

export interface Country {
  code: CountryCodeType;
  locale: LocaleType;
  name: string;
  timezone: TimeZoneType;
  language: LanguageType;
  currency: CurrencyType;
}

export const countries: Record<CountryCodeType, Country> = {
  SE: {
    code: 'SE',
    locale: 'sv-SE',
    name: 'sweden',
    timezone: 'Europe/Stockholm',
    language: 'sv',
    currency: 'SEK',
  },
  NO: {
    code: 'NO',
    locale: 'nb-NO',
    name: 'norway',
    timezone: 'Europe/Oslo',
    language: 'nb',
    currency: 'NOK',
  },
  FI: {
    code: 'FI',
    locale: 'fi-FI',
    name: 'finland',
    timezone: 'Europe/Helsinki',
    language: 'fi',
    currency: 'EUR',
  },
  DK: {
    code: 'DK',
    locale: 'da-DK',
    name: 'denmark',
    timezone: 'Europe/Copenhagen',
    language: 'da',
    currency: 'DKK',
  },
};

const countryMap = new Map<string, Country>(
  Array.from(Object.values(countries)).map((country) => [
    country.name.toLowerCase(),
    country,
  ]),
);

export const getCountry = (countryName: string): Country => {
  const country = countryMap.get(countryName.toLowerCase());
  if (country) {
    return country;
  }

  throw new Error(`There is no country with this name: ${countryName}`);
};

export default Country;
